(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusDeleteController', CompanySubscriptionStatusDeleteController);

    CompanySubscriptionStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanySubscriptionStatus'];

    function CompanySubscriptionStatusDeleteController($uibModalInstance, entity, CompanySubscriptionStatus) {
        var vm = this;

        vm.companySubscriptionStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CompanySubscriptionStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
